import type { ProposalCustomerPricingDisplay } from "./proposalCustomerPricing";

export const PROPOSAL_RETAIL_PRICE_DISCLAIMER =
  "This is the proposed retail price. Price adjustments are not reflected yet.";

/** True when customer-facing system prices omit proposal-level discounts/adjustments. */
export function proposalShowsRetailPriceDisclaimer(
  pricing?: ProposalCustomerPricingDisplay | null,
  footerAdjustmentsTotal?: number | null,
): boolean {
  if (pricing?.showFinalAgreedPrice) {
    const discount = pricing.proposalTotal - pricing.finalAgreedPrice;
    if (Number.isFinite(discount) && discount > 0.004) return true;
  }
  return Math.abs(Number(footerAdjustmentsTotal ?? 0)) > 0.004;
}
